import { Config } from "../../types";
import Weather from "./Weather";
import WeatherSettings from "./WeatherSettings";

const config: Config = {
  key: "widget/weather",
  name: "Weather",
  description: "show current weather.",
  dashboardComponent: Weather,
  settingsComponent: WeatherSettings,
};

export default config;
